<div class="modal-container">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>{{ title }}</h1>
      </div>
      <div class="modal-text mt-2">
        <span class="whitespace-pre-line">{{ instructions }}</span>
      </div>
      <button
        class="close-button"
        mat-dialog-close>
        <i class="material-symbols-rounded">close</i>
      </button>
    </div>
  </div>

  <mat-dialog-content aria-label="Add Fee Prompt">
    <div class="modal__body flex flex-col gap-8">
      <ng-container *ngIf="step === 1">
        <div class="flex flex-row gap-4 items-baseline">
          <scope-ui-input
            class="flex-1"
            inputClass="icon-field show-errors"
            [inputLabel]="questionTextLabel"
            [required]="true"
            [initialValue]="questionText"
            (onInputChange)="questionText = $event"></scope-ui-input>
        </div>

        <mat-divider></mat-divider>

        <div class="flex gap-2 flex-col">
          <h4 class="product-heading-bold scope-input-required">{{ configureTitle }}</h4>
          <scope-ui-checkbox
            title="Always"
            [ngModel]="showAlways"
            (ngModelChange)="showAlways = $event; showOnCondition = !$event"></scope-ui-checkbox>
          <scope-ui-checkbox
            title="On condition"
            [ngModel]="showOnCondition"
            (ngModelChange)="showOnCondition = $event; showAlways = !$event"></scope-ui-checkbox>
          <formula-builder
            *ngIf="showOnCondition"
            title="Set a condition"
            [scenario]="scenario"
            [required]="true"
            [showResult]="false"
            [control]="conditionControl"
            [(value)]="condition"></formula-builder>
        </div>
      </ng-container>

      <div
        *ngIf="step === 2"
        class="flex flex-col gap-2">
        <h4 class="product-heading-bold scope-input-required">Select Fees</h4>
        <div
          *ngIf="selectedFeeItems?.length > 0"
          class="table-container">
          <table
            mat-table
            class="mat-elevation-z8"
            [dataSource]="dataSource">
            <ng-container matColumnDef="pin">
              <th
                mat-header-cell
                *matHeaderCellDef>
                Pin
              </th>
              <td
                mat-cell
                *matCellDef="let row">
                <mat-icon
                  class="material-symbols-rounded item-icon pointer"
                  [ngClass]="{ 'orange fill': row.required }"
                  (click)="pinFeeItem(row)"
                  [matTooltip]="getPinTooltip(row)">
                  {{ row.required ? 'keep' : 'keep_off' }}
                </mat-icon>
              </td>
            </ng-container>
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef>
                <div
                  class="flex items-center pointer"
                  (click)="onSort('name')">
                  Fee name
                  <sort-icon
                    column="name"
                    [sortedColumn]="sortedColumn"
                    [sortDirection]="sortDirection"></sort-icon>
                </div>
              </th>
              <td
                mat-cell
                *matCellDef="let element">
                {{ element.name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th
                mat-header-cell
                *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let element">
                <mat-icon
                  class="material-symbols-rounded right orange pointer"
                  (click)="removeFeeItem(element)">
                  delete
                </mat-icon>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-slide-toggle
            class="scope-ui-toggle"
            [disableRipple]="true"
            [checked]="required"
            (change)="required = $event.checked">
            Required
          </mat-slide-toggle>
        </div>
        <div class="flex-row items-baseline">
          <prompt-autocomplete
            title="Find fee"
            [options]="feeItems$ | async"
            [optionFn]="optionFunction"
            [isFetching]="isLoading$ | async"
            [noPagination]="true"
            [isSelected]="isSelected"
            (selectedItemsChange)="updateSelectedFees($event)" />
        </div>
      </div>

      <ng-container *ngIf="step === 3">
        <div class="flex flex-row gap-8">
          <mat-button-toggle-group
            name="feeDiscount"
            aria-label="Fee or Discount"
            [formControl]="typeControl">
            <mat-button-toggle value="INCREASE">Fee</mat-button-toggle>
            <mat-button-toggle value="DECREASE">Discount</mat-button-toggle>
          </mat-button-toggle-group>

          <scope-ui-input
            class="flex-1 pt-2"
            inputClass="icon-field show-errors"
            [inputLabel]="feeNameLabel"
            [required]="true"
            [initialValue]="feeName"
            (onInputChange)="feeName = $event"></scope-ui-input>
        </div>
      </ng-container>

      <ng-container *ngIf="step > 1">
        <mat-slide-toggle
          class="scope-ui-toggle py-4"
          [disableRipple]="true"
          [checked]="enableDeliverables"
          (change)="enableDeliverables = $event.checked">
          Apply to deliverable level
        </mat-slide-toggle>

        <div
          *ngIf="enableDeliverables"
          class="flex flex-col gap-2">
          <h4 class="product-heading-bold scope-input-required">Select {{ 'deliverable.p' | lang }}</h4>
          <div
            *ngIf="selectedDeliverables.length > 0"
            class="table-container">
            <table
              mat-table
              [dataSource]="deliverableDataSource"
              class="mat-elevation-z8">
              <ng-container matColumnDef="pin">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Pin
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <mat-icon
                    class="material-symbols-rounded item-icon pointer"
                    [ngClass]="{ 'orange fill': row.required }"
                    (click)="pinDeliverable(row)"
                    [matTooltip]="getDeliverablePinTooltip(row)">
                    {{ row.required ? 'keep' : 'keep_off' }}
                  </mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="deliverable_name">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  <div
                    class="flex items-center pointer"
                    (click)="onSortDeliverable('deliverable_name')">
                    {{ 'deliverable' | lang }} Name
                    <sort-icon
                      column="deliverable_name"
                      [sortedColumn]="sortedColumn"
                      [sortDirection]="sortDirection"></sort-icon>
                  </div>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element">
                  {{ element.libraryItemName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="discipline_name">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  <div
                    class="flex items-center pointer"
                    (click)="onSortDeliverable('discipline_name')">
                    Discipline
                    <sort-icon
                      column="discipline_name"
                      [sortedColumn]="sortedColumn"
                      [sortDirection]="sortDirection"></sort-icon>
                  </div>
                </th>
                <td
                  mat-cell
                  *matCellDef="let element">
                  {{ element.disciplineName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th
                  mat-header-cell
                  *matHeaderCellDef></th>
                <td
                  mat-cell
                  *matCellDef="let element">
                  <mat-icon
                    class="material-symbols-rounded right orange pointer"
                    (click)="deleteDeliverable(element)">
                    delete
                  </mat-icon>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="displayedDeliverablesColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedDeliverablesColumns"></tr>
            </table>
          </div>
          <div class="flex-row items-baseline">
            <prompt-autocomplete
              [options]="deliverableEntryDetails$ | async"
              [optionFn]="deliverableOptionFunction"
              [isFetching]="isLoadingDeliverable$ | async"
              [lastPage]="lastPage$ | async"
              [title]="'Find ' + ('deliverable|l' | lang)"
              [isSelected]="isSelectedDeliverable"
              (onFetch)="fetchDeliverables($event)"
              (selectedItemsChange)="updateSelectedDeliverables($event)">
            </prompt-autocomplete>
          </div>
        </div>
      </ng-container>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="flex gap-3 justify-between">
    <span class="step">{{ step > 1 ? 2 : 1 }}/2</span>
    <div class="actions-right">
      <button
        mat-button
        mat-dialog-close>
        Cancel
      </button>
      <button
        mat-button
        *ngIf="step === 2"
        (click)="step = 1">
        <mat-icon class="material-symbols-rounded">chevron_left</mat-icon>
        Back
      </button>
      <button
        mat-flat-button
        class="ml-8"
        *ngIf="!(updateLoading$ | async)"
        (click)="goToStep(step)"
        [disabled]="disableNextStep()">
        {{ step === 1 ? 'Go To Next Step' : 'Save' }}
      </button>
      <button
        mat-flat-button
        class="ml-8"
        *ngIf="updateLoading$ | async">
        <img
          src="/assets/icons/loading.svg"
          alt="loading"
          class="icon-spinner" />
      </button>
    </div>
  </mat-dialog-actions>

  <mat-dialog-actions
    *ngIf="step > 1 && !selectedFeeItems?.length && !feeName && !editPage"
    class="flex gap-3 justify-between">
    <div class="custom-del-button flex justify-center">
      <button
        mat-button
        (click)="step = step == 2 ? 3 : 2">
        <span class="font-newJuneBold flex items-center">
          <mat-icon class="material-symbols-rounded orange mb-1">add</mat-icon>
          {{ step == 3 ? 'Select existing fee' : 'Create configurable fee' }}
        </span>
      </button>
    </div>
  </mat-dialog-actions>
</div>
